import { queryOptions } from '@tanstack/react-query';

import { intercultureApi } from '../apis/interculture';
import { GetDebugPanelDataDto } from '../types/dto';

import { Filters, Globals } from '@data-access';

export const intercultureQueries = (global: Globals) => ({
  all: () => [global, 'interculture'],
  types: () =>
    queryOptions({
      queryKey: [...intercultureQueries(global).all(), 'types'],
      queryFn: () => intercultureApi.getTypes(),
    }),

  crop: (crop: string) => [...intercultureQueries(global).all(), crop],
  tuto: (crop: string) =>
    queryOptions({
      queryKey: [...intercultureQueries(global).crop(crop), 'tuto'],
      queryFn: () => intercultureApi.getTuto(crop),
    }),

  lists: (crop: string) => [...intercultureQueries(global).crop(crop), 'list'],
  list: (args: { crop: string; filters: Filters }) =>
    queryOptions({
      queryKey: [...intercultureQueries(global).lists(args.crop), args.filters],
      queryFn: () => intercultureApi.getAllForms(args),
    }),

  results: (crop: string) => [
    ...intercultureQueries(global).crop(crop),
    'results',
  ],
  result: (args: { id: number; crop: string }) =>
    queryOptions({
      queryKey: [...intercultureQueries(global).results(args.crop), args.id],
      queryFn: () => intercultureApi.getResult(args),
    }),

  values: ({ crop }: { crop: string }) =>
    queryOptions({
      queryKey: [...intercultureQueries(global).crop(crop), 'values'],
      queryFn: () => intercultureApi.getValues({ crop }),
    }),

  debugPanelData: (params: GetDebugPanelDataDto) =>
    queryOptions({
      queryKey: [...intercultureQueries(global).all(), 'debugPanel', params],
      queryFn: () => intercultureApi.getDebugPanelData(params),
    }),
});
